import logger from './logger';
import logError from './logError';

// How often an ongoing-activity signal is allowed to actually reach the
// display controller. Well under DISPLAY_IDLE_TIMEOUT_MINUTES' 60-minute
// default so a continuously active user never lets the display sleep, but
// far apart enough not to hit the acquire server on every mouse move.
const ACTIVITY_WAKE_THROTTLE_MS = 5 * 60 * 1000;

let lastActivityWakeAt = 0;

/**
 * Best-effort, fire-and-forget wake signal for the device display.
 * Never throws — a failed or slow wake request must never block or fail login.
 */
export const wakeDisplay = async (acquireBaseUrl) => {
  try {
    const response = await fetch(`${acquireBaseUrl}/display/wake`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-CSRF-Token': localStorage.getItem('csrfToken'),
      },
    });
    if (!response.ok) {
      logger.error(
        logError(new Error(`Display wake failed with status ${response.status}`), {
          action: 'displayWakeFailed',
          status: response.status,
        }),
      );
    }
  } catch (error) {
    logger.error(logError(error, { action: 'displayWakeFailed' }));
  }
};

/**
 * Same as wakeDisplay, but throttled to at most one request per
 * ACTIVITY_WAKE_THROTTLE_MS — for callers invoked repeatedly on ongoing UI
 * activity (mouse/keyboard/click), rather than a one-off event like login.
 */
export const wakeDisplayOnActivity = async (acquireBaseUrl) => {
  const now = Date.now();
  if (now - lastActivityWakeAt < ACTIVITY_WAKE_THROTTLE_MS) {
    return;
  }
  lastActivityWakeAt = now;
  await wakeDisplay(acquireBaseUrl);
};
